import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

let man_run_img = $('.section1 .cont2 .img img').attr('src').split('0')

// 第一部分图片切换
let imgNum = -1
setInterval(function(){
  if(imgNum >= 14){
    imgNum = 0
  }else{
    imgNum = imgNum + 1
  }

  $('.section1 .cont2 .img .show-img').attr('src',man_run_img[0]+imgNum+'.png')
},100)

// 设置section4的高度
$(document).ready(function(){
  if($(window).width() > 1024){
    let viewH = $(window).height(); //可见高度
    $('.section4').height($('.section4 .fix-cont').outerWidth() - $(window).width() + viewH);
  }
})

$(window).resize(function(){
  if($(window).width() > 1024){
    setTimeout(function(){
      let viewH = $(window).height(); //可见高度
      $('.section4').height($('.section4 .fix-cont').outerWidth() - $(window).width() + viewH);
    },500)
  }
})

$('.header .right .nav ul li .sub-nav>div a').on('click',function(){
  if($(window).width() <= 1024){
    $('header .menu-icon').removeClass('active')
    $('header .hamburger').removeClass('active')
    $('header .nav').slideUp(400)
    setTimeout(function() {
      $('header .bg').removeClass('nav-show-mob')
    }, 400);
  }
})

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let logTop = $('.section1 .cont1 .img2').offset().top - viewH; 

  // 第一部分logo横向移动
  if (scroH > logTop) {
    let chus = 2.5
    if($(window).width()<=1024){
      chus = 8
    }
    let scrollX = (scroH - logTop) / chus
    $('.section1 .cont1 .img2').css('transform', 'translateX(-' + scrollX + 'px)')
  }

  // 第二部分
  let sec2Top = $('.section2').offset().top
  let sec2ImgTop = $('.section2 .img').offset().top
  let sec2bottom = $('.section2').offset().top + $('.section2').outerHeight()

  if($(window).width() > 1024){
    if(scroH > sec2Top && scroH < sec2bottom - viewH){
      $('.section2 .fix-cont').addClass('fixed').removeClass('abs')
    }else if( scroH >= sec2bottom - viewH){
      $('.section2 .fix-cont').removeClass('fixed').addClass('abs')
    }else{
      $('.section2 .fix-cont').removeClass('fixed').removeClass('abs')
    }
  }

  if(scroH > sec2ImgTop - viewH){
    if($(window).width() > 1024){
      $('.section2 .fix-cont .cont .img .img1').css('transform', 'translateY(-' + (scroH - sec2Top + viewH)/1.8 + 'px)')
      $('.section2 .fix-cont .cont .img .img2').css('transform', 'translateY(' + (scroH - sec2Top + viewH)/1.8 + 'px)')
    }else{
      $('.section2 .fix-cont .cont .img .img1').css('transform', 'translateX(-' + (scroH - sec2ImgTop + viewH)/5 + 'px)')
      $('.section2 .fix-cont .cont .img .img2').css('transform', 'translateX(' + (scroH - sec2ImgTop + viewH)/5 + 'px)')
    }
  }


  let sec4fixedTop = $('.section4').offset().top
  let sec4fixedBtm = $('.section4').offset().top + $('.section4').outerHeight()

  if($(window).width() > 1024){
    // 设置section4的内容浮动
    if(scroH > sec4fixedTop && scroH < sec4fixedBtm - viewH){
      $('.section4 .fix-cont').addClass('fixed').removeClass('abs')
      // 设置section4的内容横向滚动
      $('.section4 .fix-cont .cont').css('transform', 'translateX(-' + (scroH - sec4fixedTop) + 'px)')
    }else if( scroH >= sec4fixedBtm - viewH){
      $('.section4 .fix-cont').removeClass('fixed').addClass('abs')
    }else{
      $('.section4 .fix-cont').removeClass('fixed').removeClass('abs')
      $('.section4 .fix-cont .cont').css('transform', 'translateX(0px)')
    }
  }
});

